import { Modal as CosmaModal } from 'is24-corecss';
import type { ComponentProps } from 'react';
import { useState } from 'react';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { useIntl } from '@/i18n';
import { ActivationForm } from './ActivationForm';

const { V3: Modal } = Modals;

export const AdacActivationApplicationModal = ({
  onClose,
  onSubmitted,
}: Pick<BenefitModalProps, 'onClose'> & Pick<ComponentProps<typeof ActivationForm>, 'onSubmitted'>) => {
  const { t } = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dismissApplication = () => {
    if (isSubmitting) {
      return;
    }
    onClose();
  };

  return (
    <Modal isVisible onClose={dismissApplication} compact>
      <Modal.Header>
        <Modal.Title>{t({ id: 'benefits.adac.headline' })}</Modal.Title>
        <Modal.CloseButton />
      </Modal.Header>
      <Modal.Content className='absolute-reference padding-horizontal-l palm-padding-horizontal-xl'>
        <ActivationForm onSubmitted={onSubmitted} onSubmittingChange={setIsSubmitting} />
      </Modal.Content>
      <Modal.Footer>
        <CosmaModal.FooterButton
          variant='textDefault'
          label={t({ id: 'common.aragModal.form.cancelButtonText' })}
          onClick={onClose}
          disabled={isSubmitting}
        />
        <CosmaModal.FooterButton
          variant='filledBrand'
          label={t({ id: 'common.aragModal.form.saveButtonText' })}
          type='submit'
          form='adac-application'
          loading={isSubmitting}
          disabled={isSubmitting}
        />
      </Modal.Footer>
    </Modal>
  );
};
